import React, { useEffect, useState } from "react";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Swal from "sweetalert2";
import MessageDetail from "../components/MessageDetail";
import Header from "../components/Header";
import RowRaces from "../components/TableRaces/RowRaces";
import { useWebSocket } from "../services/WebSocketProvider";
import { helpAxios } from "../helpers/helpAxios";
import ApiCall from "../constants/Api";
import { errorHandler } from "../components/ErrorHandler";
import SiteConfig from "../constants/SiteConfig";

export const Dashboard = ({
  data,
  logout,
  setLoginInfo,
  setSessionNoLongerExists,
}) => {
  const { lastMessage } = useWebSocket();
  const [statusMessages, setStatusMessages] = useState("");
  const [racesMessages, setRacesMessages] = useState([]);
  const [scoringMessages, setScoringMessages] = useState([]);
  const [messageDetails, setMessageDetails] = useState("");
  const [messageSelected, setMessageSelected] = useState(1);
  const [messageSelectedScoring, setMessageSelectedScoring] = useState(1);
  const [messageSelectedFM, setMessageSelectedFM] = useState(1);
  const [popupStatus, setPopupStatus] = useState(false);
  const [popupStatusRaces, setPopupStatusRaces] = useState(false);
  const [operatorMessages, setOperatorMessages] = useState([]);
  const [operatorMessagesPopUp, setOperatorMessagesPopUp] = useState([]);
  const [errorMessagesPopUp, setErrorMessagesPopUp] = useState([]);
  const MAX_MESSAGES = window.config?.SiteConfig?.MAX_MESSAGES_SHOW ?? 10;
  const [systemPreferences, setSystemPreferences] = useState({});

  const handleUnload = () => {
    setLoginInfo({ UUID: "" });
  };

  useEffect(() => {
    window.addEventListener("unload", handleUnload);
    return () => {
      window.removeEventListener("unload", handleUnload);
    };
  }, []);

  useEffect(() => {
    if (!lastMessage || !lastMessage.MessageType) return;

    switch (lastMessage.MessageType) {
      case "process":
      case "race-create":
      case "entry-create":
      case "close":
      case "error":
      case "warning":
      case "result-create":
      case "pool":
      case "entry-change":
      case "race-change":
        setRacesMessages((prevState) =>
          [lastMessage, ...prevState].slice(0, MAX_MESSAGES),
        ); // Limit the array size
        setMessageSelected({ ...lastMessage, ChangeIndex: 0 });
        break;
      case "ping":
        setStatusMessages(lastMessage);
        break;
      case "operator":
        setOperatorMessages((prevState) =>
          [lastMessage, ...prevState].slice(0, MAX_MESSAGES),
        ); // Limit the array size
        if (popupStatus) {
          setOperatorMessagesPopUp((prevMessages) =>
            [...prevMessages, lastMessage].slice(0, MAX_MESSAGES),
          ); // Limit the popup array size
        }
        setMessageSelectedFM(lastMessage);
        break;
      case "criticalerror":
        setErrorMessagesPopUp((prevMessages) =>
          [...prevMessages, lastMessage].slice(0, MAX_MESSAGES),
        ); // Limit the popup array size
        break;
      case "UnScore":
      case "Score":
      case "Process":
        setScoringMessages((prevState) =>
          [lastMessage, ...prevState].slice(0, MAX_MESSAGES),
        ); // Limit the array size
        setMessageSelectedScoring(lastMessage);
        break;
      case "packages":
        const trackPackages = lastMessage.Object?.TrackPackages || [];

        setSystemPreferences((prev) => ({
          ...prev,
          TrackPackages: trackPackages,
        }));

        break;
      default:
        break;
    }
  }, [lastMessage]);

  useEffect(() => {
    let objDiv;
    if (popupStatusRaces) {
      objDiv = document.getElementById("races_div");
      objDiv.scrollTop = objDiv.scrollHeight;
      objDiv = document.getElementById("scoring_div");
      objDiv.scrollTop = objDiv.scrollHeight;
      objDiv = document.getElementById("messages_div");
      objDiv.scrollTop = objDiv.scrollHeight;
    } else {
      objDiv = document.getElementById("races_div");
      objDiv.scrollTop = 0;
      objDiv = document.getElementById("scoring_div");
      objDiv.scrollTop = 0;
      objDiv = document.getElementById("messages_div");
      objDiv.scrollTop = 0;
    }
  });

  // Function to get the month name from its number
  function getMonthName(monthNumber) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[parseInt(monthNumber) - 1];
  }

  const getFormatDate = (originalDate) => {
    // Get date components
    const date = new Date(originalDate);
    let hour = date.getHours();
    let minutes = date.getMinutes();
    // Get the month name
    const monthName = getMonthName(date.getMonth() + 1);
    if (hour < 10) hour = "0" + hour;
    if (minutes < 10) minutes = "0" + minutes;
    return date.getDate() + " " + monthName + " / " + hour + ":" + minutes;
  };

  const racesStatus = (raceSatus) => {
    switch (raceSatus) {
      case "B":
        return "Off";
      case "O":
        return "Open";
      case "X":
        return "Cancel";
      case "C":
        return "Complete";
      default:
        return;
    }
  };

  let operatorMessagesRows = [],
    raceMessagesRows = [],
    scoringMessagesRows = [],
    statusDiv;

  if (statusMessages !== "") {
    statusDiv = (
      <strong>
        Status: {statusMessages.ProcessDateTime} {statusMessages.MessageType}
        <br></br>
        {statusMessages.Message} Received from {statusMessages.ComputerIP}
      </strong>
    );
  }

  let operatorMsg = popupStatusRaces
    ? [...operatorMessages].reverse()
    : operatorMessages;
  // operator messages
  operatorMsg.forEach((item, index) => {
    let background =
      messageSelectedFM?.IDMessage === item.IDMessage ? "#ccf1ff" : "";
    operatorMessagesRows.push(
      <li
        className="list-group-item"
        key={index}
        style={{ backgroundColor: background }}
        onClick={() => {
          setMessageSelectedFM(item);
          setMessageDetails(item);
        }}
      >
        {" " + getFormatDate(item.ProcessDateTime) + " "}
        <span
          className="badge bg-primary"
          style={{ backgroundColor: window.config.SiteColors.operator }}
        >
          Message
        </span>
        {" " + item.Message}
      </li>,
    );
  });

  let racesMsg = popupStatusRaces
    ? [...racesMessages].reverse()
    : racesMessages;

  //races messages
  racesMsg.forEach((item, index) => {
    let background = "";

    const isSelected = messageSelected?.IDMessage === item.IDMessage;

    if (isSelected) {
      background = "#ccf1ff";
    } else if (item.ServiceName && item.ServiceName !== "Feed") {
      background = window.config.SiteColors.otherSourceColor;
    }
    let label = "";
    switch (item.MessageType) {
      case "race-change":
      case "race-create":
        label = "Race";
        break;
      case "entry-change":
      case "entry-create":
        label = "Entry";
        break;
      case "pool":
        label = "Pool";
        break;
      case "result-change":
      case "result-create":
        label = "Results";
        break;
      case "close":
        label = "Close";
        break;
      case "error":
        label = "Error";
        break;
      case "warning":
        label = "Warning";
        break;
      case "process":
        label = "Process";
        break;
      default:
        break;
    }

    switch (item.MessageType) {
      case "process":
      case "close":
      case "error":
      case "warning":
        let badge = window.config.SiteColors.close;
        if (item.MessageType === "process") {
          badge = window.config.SiteColors.process;
        }
        if (item.MessageType === "warning") {
          badge = window.config.SiteColors.warning;
        }
        if (item.MessageType === "error") {
          badge = window.config.SiteColors.error;
        }
        raceMessagesRows.push(
          <RowRaces
            key={index}
            background={background}
            item={item}
            msg={label + ": " + item.Message}
            title={
              item.TrackCode !== ""
                ? "(" + item.TrackCode + ") " + item.TrackName
                : ""
            }
            type={label}
            onClick={() => {
              setMessageSelected(item);
              setMessageDetails(item);
            }}
            badge={badge}
          />,
        );
        break;
      case "race-create":
      case "pool":
      case "entry-create":
        raceMessagesRows.push(
          <RowRaces
            key={index}
            background={background}
            item={item}
            title={"(" + item.TrackCode + ") " + item.TrackName}
            msg={"Race #" + item.RaceNumber + " - " + label + " inserted"}
            type={label}
            onClick={() => {
              setMessageSelected(item);
              setMessageDetails(item);
            }}
            badge={window.config.SiteColors.create}
          />,
        );
        break;
      case "result-create":
        const badgeRes = item.Errors?.length
          ? window.config.SiteColors.error
          : window.config.SiteColors.create;
        const msgRes = item.Errors?.length
          ? `Race #${item.RaceNumber} - ${label} had errors inserting`
          : `Race #${item.RaceNumber} - ${label} inserted successfully`;
        raceMessagesRows.push(
          <RowRaces
            key={index}
            background={background}
            item={item}
            title={"(" + item.TrackCode + ") " + item.TrackName}
            msg={msgRes}
            type={label}
            onClick={() => {
              setMessageSelected(item);
              setMessageDetails(item);
            }}
            badge={badgeRes}
          />,
        );
        break;
      case "entry-change":
      case "race-change":
        item.Changes.forEach((element, i) => {
          const isSelected =
            item.IDMessage === messageSelected?.IDMessage &&
            messageSelected?.ChangeIndex === i;

          let bg = "";

          if (isSelected) {
            bg = "#ccf1ff";
          } else if (item.ServiceName && item.ServiceName !== "Feed") {
            bg = window.config.SiteColors.otherSourceColor;
          }
          let chang = element.NewValue === "" ? "Empty" : element.NewValue;
          if (chang === "-1") chang = "SCR";
          let message =
            element.Field === "RaceStatus"
              ? `Race #${item.RaceNumber} - Change Status ${racesStatus(chang)}`
              : `Race #${item.RaceNumber} - Change ${element.Field} : ${chang}`;
          raceMessagesRows.push(
            <RowRaces
              key={element.Field + item.RaceID + i + index}
              background={bg}
              item={item}
              title={"(" + item.TrackCode + ") " + item.TrackName}
              msg={message}
              type={label}
              onClick={() => {
                setMessageSelected({ ...item, ...element, ChangeIndex: i });
                setMessageDetails({ ...item, ...element, ChangeIndex: i });
              }}
              badge={window.config.SiteColors.update}
            />,
          );
        });
        break;
      default:
        break;
    }
  });

  //scoring messages
  let scoringMsg = popupStatusRaces
    ? [...scoringMessages].reverse()
    : scoringMessages;
  scoringMsg.forEach((item, index) => {
    let background = "";

    const isSelected = messageSelectedScoring?.IDMessage === item.IDMessage;

    if (isSelected) {
      background = "#ccf1ff";
    } else if (item.ServiceName && item.ServiceName !== "Feed") {
      background = window.config.SiteColors.otherSourceColor;
    }

    let badge = "";
    switch (item.MessageType) {
      case "UnScore":
        badge = window.config.SiteColors.unscore;
        break;
      case "Score":
        badge = window.config.SiteColors.score;
        break;
      case "Process":
        badge = window.config.SiteColors.process;
        break;
      default:
        break;
    }

    let msg =
      item.MessageType === "Process"
        ? `Process : ${item.Message}`
        : `Race #${item.RaceNumber} ${item.MessageType}`;

    scoringMessagesRows.push(
      <RowRaces
        key={item.IDMessage}
        background={background}
        item={item}
        msg={msg}
        title={
          item.MessageType === "Process"
            ? `(${item.TrackCode})`
            : `(${item.TrackCode}) ${item.TrackName}`
        }
        type={item.MessageType}
        onClick={() => {
          setMessageSelectedScoring(item);
          setMessageDetails(item);
        }}
        badge={badge}
      />,
    );
  });

  useEffect(() => {
    if (!popupStatus || operatorMessagesPopUp.length === 0) return;
    const element = operatorMessagesPopUp[0];
    Swal.fire({
      title: "New message",
      html: `${element.ProcessDateTime}</br>${element.Message}`,
      icon: "info",
      allowOutsideClick: false,
      padding: "3em",
    }).then((result) => {
      if (result.value) {
        setOperatorMessagesPopUp((current) =>
          current.filter((item) => item.IDMessage !== element.IDMessage),
        );
      }
    });
  }, [operatorMessages, operatorMessagesPopUp, popupStatus]);

  useEffect(() => {
    if (!errorMessagesPopUp.length) return;

    let index = 0;

    const showNextElement = () => {
      if (index >= errorMessagesPopUp.length) return;

      const element = errorMessagesPopUp[index];

      Swal.fire({
        title: "Error",
        html: element.ProcessDateTime + "<br/>" + element.Message,
        icon: "error",
        allowOutsideClick: false,
        padding: "3em",
      }).then((result) => {
        if (result.isConfirmed) {
          setErrorMessagesPopUp((current) =>
            current.filter((item) => item.IDMessage !== element.IDMessage),
          );
        }

        index++;
        showNextElement();
      });
    };

    showNextElement();
  }, [errorMessagesPopUp]);

  const validateSession = () => {
    setSessionNoLongerExists(false);
    const fetchData = async () => {
      const res = await helpAxios(
        ApiCall.VALIDATE_USER_SESSION,
        {},
        data.UUID,
        SiteConfig.USER_ACCESS_SVC,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }

        if (res.Result === -7002 || res.Result === -1101) {
          setSessionNoLongerExists(true);
        }
      }
    };

    fetchData();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      validateSession();
    }, window.config.SiteConfig.RefreshLapse);

    return () => clearInterval(interval);
  }, []);

  const changeDirectionMessages = () => {
    Swal.fire({
      title: "Would you like to continue?",
      text: "Performing this action will clear the list of current messages",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        setRacesMessages([]);
        setPopupStatusRaces(!popupStatusRaces);
      }
    });
  };

  return (
    <div className="vh-100">
      <Header
        logout={logout}
        data={data}
        setSessionNoLongerExists={setSessionNoLongerExists}
        systemPreferences={systemPreferences}
        setSystemPreferences={setSystemPreferences}
      />
      <div className="row h-100 container-responsive">
        <div className="col-sm-4 h-100">
          <div className="card h-100">
            <div className="card-header d-flex justify-content-between">
              <span>Races</span>
              <span>
                <label
                  className="switch"
                  id="races-element"
                  data-tooltip-content="Change message direction"
                >
                  <input
                    type="checkbox"
                    onChange={() => changeDirectionMessages()}
                    checked={popupStatusRaces}
                  />
                  <span className="slider round"></span>
                </label>
                <span className="clear-color">
                  <i
                    className="fas fa-broom"
                    data-tooltip-content="Clear messages"
                    id="delete-element"
                    onClick={() => setRacesMessages([])}
                  ></i>
                </span>
              </span>
            </div>
            <div style={{ overflowY: "auto" }} id="races_div">
              <table className="table table-sm text-center table-hover">
                <thead className="border-bottom theadFixed">
                  <tr>
                    <th scope="col-md-2">DateTime</th>
                    <th scope="col-md-2">Type</th>
                    <th scope="col-md-7">Message</th>
                  </tr>
                </thead>
                <tbody>{raceMessagesRows.slice(0, MAX_MESSAGES)}</tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-sm-4 h-100 p-0">
          <div className="card h-100">
            <div className="card-header d-flex justify-content-between">
              Scoring
              <span className="clear-color">
                <i
                  className="fas fa-broom"
                  data-tooltip-content="Clear messages"
                  id="delete-element2"
                  onClick={() => setScoringMessages([])}
                ></i>
              </span>
            </div>
            <div style={{ overflowY: "auto" }} id="scoring_div">
              <table className="table table-sm text-center table-hover table-striped">
                <thead className="border-bottom theadFixed">
                  <tr>
                    <th scope="col-md-2">DateTime</th>
                    <th scope="col-md-2">Type</th>
                    <th scope="col-md-7">Message</th>
                  </tr>
                </thead>
                <tbody>{scoringMessagesRows.slice(0, MAX_MESSAGES)}</tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-sm-4 h-100">
          <div className="col-md-12 pb-2 h-50">
            <div className="card h-100">
              <div className="card-header d-flex justify-content-between">
                <span>Feed Messages</span>
                <span>
                  <span className="mr-2">
                    <label
                      className="switch mr-2"
                      id="operator-element"
                      data-tooltip-content="Active pop-up message"
                    >
                      <input
                        type="checkbox"
                        onChange={() => setPopupStatus(!popupStatus)}
                        checked={popupStatus}
                      />
                      <span className="slider round"></span>
                    </label>
                  </span>
                  <span className="clear-color ml-2">
                    <i
                      className="fas fa-broom"
                      data-tooltip-content="Clear messages"
                      id="delete-element3"
                      onClick={() => setOperatorMessages([])}
                    ></i>
                  </span>
                </span>
              </div>
              <div style={{ overflowY: "auto" }} id="messages_div">
                <ul className="list-group list-group-flush">
                  {operatorMessagesRows.slice(0, MAX_MESSAGES)}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-12 h-50">
            <div
              className="card h-100"
              style={{
                backgroundColor:
                  messageDetails?.ServiceName &&
                  messageDetails.ServiceName !== "Feed" &&
                  messageDetails.MessageType !== "operator"
                    ? window.config.SiteColors.otherSourceColor
                    : undefined,
              }}
            >
              <div className="card-header">Message Detail</div>

              {messageDetails && (
                <div style={{ overflowY: "auto" }}>
                  <MessageDetail
                    info={messageDetails}
                    racesStatus={racesStatus}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="rmqModal"
        tabIndex={"-1"}
        aria-labelledby="rmqModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id="rmqModalLabel"
                style={{ color: "black" }}
              >
                <b>RMQ Configuration</b>
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <h3>
                <b>RMQ Server: {window.config.RMQConfig.URL}</b>
              </h3>
              <h5>User: {window.config.RMQConfig.User}</h5>
              <h5>Virtual Host: {window.config.RMQConfig.VirtualHost}</h5>
              <h5>Exchange: {window.config.RMQConfig.Exchange}</h5>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <ReactTooltip anchorId="races-element" place="bottom" />
      <ReactTooltip anchorId="operator-element" place="bottom" />
      <ReactTooltip anchorId="delete-element" place="bottom" />
      <ReactTooltip anchorId="delete-element2" place="bottom" />
      <ReactTooltip anchorId="delete-element3" place="bottom" />

      <footer
        style={{ background: "#006699", height: "60px", color: "#ccf1ff" }}
        className="footer-fixed"
      >
        <div className="d-flex justify-content-between">
          <div className="col-md-3 p-2">{statusDiv}</div>
          <div className="col-md-6 p-3 text-center">
            <span></span>
          </div>
          <div className="col-md-3 p-3 text-end"></div>
        </div>
      </footer>
    </div>
  );
};
